import React, {useEffect, useState} from "react";
import {Route, Switch, useHistory} from "react-router-dom";
import {Button} from "@mui/material";
import Login from "./Pages/Vets/Login";
import VetsInvoicing from "./Pages/Vets/VetsInvoicing";
import VetDashboard from "./Pages/Vets/VetDashboard";
import VetsReporting from "./Pages/Vets/VetsReporting";
import VouchersTable from "./Pages/Vets/VouchersTable/VouchersTable";
import VouchersTableUnused from "./Pages/Vets/VouchersTable/VouchersTableUnused";
import VouchersFind from "./Pages/Vets/VouchersFind/VouchersFind";
import NotFound from "./Pages/NotFound";
import './App.css';
import VetsDetails from "./Pages/Vets/VetsDetails";
import VetCampaignsInArea from "./Pages/Vets/VetCampaignsInArea";
import FunctionsData from "../src/Functions/FunctionsData";
import MicrochipsPage from "./Pages/Vets/MicrochipsPage";
import LinkedClinics from "./Pages/Vets/LinkedClinics";

function App() {

	let history = useHistory();
	const [valid, setValid] = React.useState(false);
	const [vetId, setVetId] = React.useState(false);
	const [vet, setVet] = React.useState(false);
	const [businessName, setbusinessName] = React.useState(false);
	const [current,setCurrent] = useState(window.location.pathname ?? '/');
	const [loading, setLoading] = useState(true);

	const [optoutPublic, setOptoutPublic] = useState(true);
	const [optoutCommunity, setOptoutCommunity] = useState(true);
	const [optoutMicroChipOnly,setOptoutMicroChipOnly]=useState(false);

	useEffect(() => {
		fetch(FunctionsData.getApiUrl('/api/search/a1/vet'))
			.then(res => res.json())
			.then((r) => {
				// console.log('/api/search/a1/vet',r);
				localStorage.setItem("tkn", r.data)
			});
	}, [])

	useEffect(() => {

		fetch(FunctionsData.getApiUrl('/api/search/a1/verify'),
			{
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({'tkn': localStorage.vTkn ?? ''})
			})
			.then(res => res.json())
			.then((r) => {
				console.log('/api/search/a1/verify', r)
				if (r.data !== undefined) {
					setVetId(r.data.id);
					setVet(r.data);
					setValid(true);
				}
				setLoading(false);
			});
	}, []);

	function link(e,target) {
		e.preventDefault();
		setCurrent(target);
		history.push(target);
	}

	// if (loading === true) return null;

	if (valid === false || vet === false) return (
		<Login/>
	)

	if (valid === true && vet !== false) return (

		<div className="App" style={{padding:20}}>
			<h1 style={{padding: 20, margin: '20px 0'}}>
				SPCA Desexing Campaign - Vet access platform
				<Button sx={{marginLeft: 2}} variant={"contained"} onClick={() => {
					localStorage.clear();
					window.location.reload();
				}}>Log out</Button>

				<div style={{fontSize: '0.5em', fontWeight: 'normal'}}>{vet.business_name}, {vet.email}</div>
			</h1>
			<div className={"menu"}>
				<div className={(current === '/') ? 'active' : ''} onClick={(e) => link(e,'/')}>
					<a href="#" onClick={(e) => link(e,'/')}>Dashboard</a>
				</div>
				<div className={(current === '/vouchers') ? 'active' : ''} onClick={(e) => link(e,'/vouchers')}>
					<a href="#" onClick={(e) => link(e,'/vouchers')}>Vouchers assigned to me</a>
				</div>
				<div className={(current === '/unusuedvouchers') ? 'active' : ''} onClick={(e) => link(e,'/unusuedvouchers')}>
					<a href="#" onClick={(e) => link(e,'/unusuedvouchers')}>Unused Vouchers</a>
				</div>
				<div className={(current === '/find') ? 'active' : ''} onClick={(e) => link(e,'/find')}>
					<a href="#" onClick={(e) => link(e,'/find')}>Find any voucher</a>
				</div>
				<div className={(current === '/report') ? 'active' : ''} onClick={(e) => link(e,'/report')}>
					<a href="#" onClick={(e) => link(e,'/report')}>Report</a>
				</div>
				<div className={(current === '/schedules') ? 'active' : ''} onClick={(e) => link(e,'/schedules')}>
					<a href="#" onClick={(e) => link(e,'/schedules')}>To be invoiced</a>
				</div>
				<div className={(current === '/details') ? 'active' : ''} onClick={(e) => link(e,'/details')}>
					<a href="#" onClick={(e) => link(e,'/details')}>My details</a>
				</div>
				<div className={(current === '/campaigns') ? 'active' : ''} onClick={(e) => link(e,'/campaigns')}>
					<a href="#" onClick={(e) => link(e,'/campaigns')}>Campaigns</a>
				</div>
				<div className={(current === '/microchips') ? 'active' : ''} onClick={(e) => link(e,'/microchips')}>
					<a href="#" onClick={(e) => link(e,'/microchips')}>Microchips</a>
				</div>
				<div className={(current === '/linkedclinics') ? 'active' : ''} onClick={(e) => link(e,'/linkedclinics')}>
					<a href="#" onClick={(e) => link(e,'/linkedclinics')}>Linked Clinics</a>
				</div>
			</div>
			<div>
				<Switch>
					<Route exact path="/details">
						<VetsDetails vet_id={vetId} key={5} optoutPublic={optoutPublic}
							setOptoutPublic={setOptoutPublic}
							optoutCommunity={optoutCommunity}
							setOptoutCommunity={setOptoutCommunity}
							optoutMicroChipOnly={optoutMicroChipOnly}
							setOptoutMicroChipOnly={setOptoutMicroChipOnly} />
					</Route>
					<Route exact path="/schedules">
						<VetsInvoicing vet_id={vetId} key={4}/>
					</Route>
					<Route exact path="/report">
						<VetsReporting vet_id={vetId} key={2}/>
					</Route>
					<Route exact path="/find">
						<VouchersFind vet_id={vetId} key={3}/>
					</Route>
					<Route exact path="/vouchers">
						<VouchersTable vet_id={vetId} key={1}     businessName = {vet.business_name} setbusinessName = {vet.business_name}/>
					</Route>
					<Route exact path="/unusuedvouchers">
						<VouchersTableUnused vet_id={vetId} key={1}     businessName = {vet.business_name} setbusinessName = {vet.business_name}/>
					</Route>
					<Route exact path="/campaigns">
						<VetCampaignsInArea vet_id={vetId} optoutPublic={optoutPublic}
							optoutCommunity={optoutCommunity}/>
					</Route>
					<Route exact path="/microchips">
						<MicrochipsPage vet_id={vetId} />
					</Route>
					<Route exact path="/linkedclinics">
						<LinkedClinics vet_id={vetId} />
					</Route>
					<Route exact path="/">
						<VetDashboard vet_id={vetId} key={0} setCurrent={setCurrent} />
					</Route>
					<Route path="*">
						<NotFound/>
					</Route>
				</Switch>

			</div>
		</div>
	)

}

export default App;
